import React, { useEffect, useMemo, useState } from 'react';

const INSTALL_PROMPT_HIDE_KEY = 'installPromptHiddenForSession';

const InstallPrompt = () => {
  const [promptEvent, setPromptEvent] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [hiddenForSession, setHiddenForSession] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.sessionStorage.getItem(INSTALL_PROMPT_HIDE_KEY) === '1';
  });
  const isStandalone = useMemo(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  }, []);

  useEffect(() => {
    const handleBeforeInstall = (event) => {
      event.preventDefault();
      setPromptEvent(event);
    };
    const handleInstalled = () => {
      setPromptEvent(null);
      setIsInstalled(true);
    };
    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    window.addEventListener('appinstalled', handleInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
      window.removeEventListener('appinstalled', handleInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!promptEvent) return;
    promptEvent.prompt();
    await promptEvent.userChoice;
    setPromptEvent(null);
  };

  const handleHide = () => {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(INSTALL_PROMPT_HIDE_KEY, '1');
    }
    setHiddenForSession(true);
  };

  if (isStandalone || isInstalled || hiddenForSession || !promptEvent) return null;

  return (
    <div className="install-banner">
      <span>Install the app for a faster, native-like experience.</span>
      <div className="install-banner__actions">
        <button onClick={handleInstall}>Install</button>
        <button className="install-banner__hide" onClick={handleHide}>Hide</button>
      </div>
    </div>
  );
};

export default InstallPrompt;
